import {Observable} from 'rxjs';
import {inject, Injectable} from '@angular/core';

import {GetUsuryRateUseCasePort} from '@features/setting/application/use_cases/get-usury-rate//get-usury-rate.use-case.port';

import {GetUsuryRateResponseDto} from '@features/setting/application/use_cases/get-usury-rate/dto/get-usury-rate.response.dto';
import {GetUsuryRatePayloadDto} from '@features/setting/application/use_cases/get-usury-rate/dto/get-usury-rate.payload.dto';


@Injectable()
export class GetUsuryRateUseCase implements GetUsuryRateUseCasePort {

  private readonly _port: GetUsuryRateUseCasePort = inject(GetUsuryRateUseCasePort);

  public execute(payload: GetUsuryRatePayloadDto): Observable<GetUsuryRateResponseDto> {
    return this._port.execute(payload);
  }
}
